module.exports = __webpack_public_path__ + "img/logo_botafogo.3d1e73be.png";